import { v4 as uuidv4 } from "uuid";
export class PAFormQuestionComboModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.isArchived = false;
        this.status = "";
        this.hasResponses = false;
        this.createdBy = uuidv4();
        this.questions = [];
    }
}
export default class FormQuestionCombo extends PAFormQuestionComboModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
